import React, { useEffect, useState } from "react";

const SectionTitle = ({
  subtitle,
  title,
  description,
  textAlignment,
  textColor,
}) => {
    const [isTabletOrBelow, setIsTabletOrBelow] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        setIsTabletOrBelow(window.innerWidth <= 1024);
      };
  
      handleResize(); // Initial run
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
  return (
    <div className={`section-heading ${textAlignment} ${textColor}`}
    style={{ marginBottom: isTabletOrBelow ? "10px" : undefined }} // Or whatever margin you want
    >
      <div
        className="subtitle1"
        dangerouslySetInnerHTML={{ __html: subtitle }}
      ></div>
      <h2 className="title" dangerouslySetInnerHTML={{ __html: title }}></h2>
      <p dangerouslySetInnerHTML={{ __html: description }}></p>
    </div>
  );
};

export default SectionTitle;
